/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type useZKeyEnabledLocal = {
    readonly enableCommentSeen: boolean;
    readonly enableZKey: boolean;
    readonly " $refType": "useZKeyEnabledLocal";
};
export type useZKeyEnabledLocal$data = useZKeyEnabledLocal;
export type useZKeyEnabledLocal$key = {
    readonly " $data"?: useZKeyEnabledLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"useZKeyEnabledLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useZKeyEnabledLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enableCommentSeen",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enableZKey",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = '85011214ed5c341260e047103978bc3e';
export default node;
